import { YesNoGroupButtonService } from './yes-no-group-button.service';
import { Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
import { IdProvider } from '../id-provider';

@Component({
    selector: 'app-yes-no-group-button',
    templateUrl: './yes-no-group-button.component.html',
    styleUrls: ['./yes-no-group-button.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => YesNoGroupButtonComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => YesNoGroupButtonComponent),
            multi: true
        }
    ],
    imports: [ReactiveFormsModule, NgClass, TranslateModule]
})
export class YesNoGroupButtonComponent implements OnInit, ControlValueAccessor, OnDestroy {

  @Input() public yesLabel = 'i18n.shared.yes';
  @Input() public noLabel = 'i18n.shared.no';
  @Input() public allowNull: boolean = false;

  public id: string = IdProvider.getNextId();
  public form: FormGroup<{ formValue: FormControl<boolean> }>;
  public disabled: boolean;

  private subscriptions: Subscription[] = [];

  constructor(private formBuilder: FormBuilder, private service: YesNoGroupButtonService) {
    this.form = this.formBuilder.group({
      formValue: this.formBuilder.control<boolean>(false)
    });

    this.subscriptions.push(
      // any time the inner form changes update the parent of any change
      this.form.valueChanges.subscribe(value => {
        this.onChange(value?.formValue);
        this.onTouched();
      })
    );
  }

  public ngOnInit(): void {
    if (!this.id) {
      this.id = this.service.getNextId();
    }
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  public onChange: any = () => { };
  public onTouched: any = () => { };

  public writeValue(value: any): void {
    if (value == null) {
      value = this.allowNull ? null : false;
    }

    this.form.controls.formValue.setValue(value);
    this.onChange(value);
    this.onTouched();
  }

  public registerOnChange(fn): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn): void {
    this.onTouched = fn;
  }

  public setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
    if (this.disabled) {
      this.form.controls.formValue.disable();
    } else {
      this.form.controls.formValue.enable();
    }
  }

  public validate(_: FormControl): any {
    return null;
  }

}
